<template>
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.99957 3.01855C3.895 3.01855 2.99957 3.91399 2.99957 5.01855V19C2.99957 20.1046 3.895 21 4.99957 21H19C20.1046 21 21 20.1046 21 19V5.01855C21 3.91399 20.1046 3.01855 19 3.01855H4.99957ZM5.50244 19H8.20947L9.36725 15.5478H14.6306L15.7905 19H18.4975L13.562 5H10.4311L5.50244 19ZM13.9461 13.5107L12.0513 7.87109H11.9419L10.0505 13.5107H13.9461Z"
    />
  </svg>
</template>
